
import { Settings, Download, Smartphone } from 'lucide-react';
import { Button } from '@/components/ui/button';
import trucks52Logo from '@/assets/trucks52-logo-optimized.png';
import { usePWAInstall } from '@/hooks/usePWAInstall';

interface HeaderProps {
  onAdminClick: () => void;
  isAdmin: boolean;
}

export const Header = ({ onAdminClick, isAdmin }: HeaderProps) => {
  const { canInstall, isInstalled, install } = usePWAInstall();

  return (
    <header className="bg-white shadow-lg border-b border-gray-200 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center space-x-4">
            <div className="relative">
              <img 
                src={trucks52Logo} 
                alt="Trucks 52 Logo - Spécialiste en véhicules industriels d'occasion" 
                className="h-14 w-auto"
                width="56"
                height="56"
                loading="eager"
              />
            </div>
            <div>
              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 leading-tight">
                Trucks 52 SARL
              </h1>
              <p className="text-sm md:text-base text-blue-600 font-medium">
                Spécialiste poids lourds d'occasion
              </p>
            </div>
          </div>
          
          <div className="flex items-center space-x-2 sm:space-x-4">
            {/* PWA Install button */}
            {canInstall && (
              <Button
                onClick={install}
                variant="outline"
                size="sm"
                className="border-blue-300 text-blue-600 hover:bg-blue-50 flex items-center gap-1.5"
              >
                <Smartphone className="h-4 w-4" />
                <span className="hidden sm:inline">Installer l'app</span>
              </Button>
            )}

            {isInstalled && (
              <span className="text-xs text-green-600 font-medium hidden sm:inline">
                ✓ App installée
              </span>
            )}

            {/* Contact info - hidden on mobile */}
            <div className="hidden lg:block text-right">
              <div className="text-sm text-gray-600">Appelez-nous</div>
              <a 
                href="tel:+33608248529" 
                className="text-lg font-bold text-blue-600 hover:text-blue-700 transition-colors"
              >
                06 08 24 85 29
              </a>
            </div>
            
            <Button
              onClick={onAdminClick}
              variant={isAdmin ? "default" : "outline"}
              className={`flex items-center space-x-2 ${
                isAdmin 
                  ? 'bg-blue-600 hover:bg-blue-700 text-white' 
                  : 'border-gray-300 text-gray-700 hover:bg-gray-50'
              }`}
            >
              <Settings className="h-4 w-4" />
              <span className="hidden sm:inline">
                {isAdmin ? 'Mode Client' : 'Administration'}
              </span>
            </Button>
          </div>
        </div>
      </div>
    </header>
  );
};
